import _ from "lodash";
import moment from "moment-mini";
import numeral from "numeral";
import Swal from "sweetalert2";

export function differentObject(object, base) {
  function changes(object, base) {
    return _.transform(object, function (result, value, key) {
      if (_.isArray(value)) {
        if (!_.isEqual(value, base[key])) {
          result[key] = value;
        }
      } else {
        if (!value && !base[key]) {
        } else {
          if (!_.isEqual(value, base[key])) {
            result[key] =
              !(value instanceof Date) &&
              _.isObject(value) &&
              _.isObject(base[key])
                ? changes(value, base[key])
                : value;
          }
        }
      }
    });
  }
  return changes(object, base);
}

export function getUrlQuery(name, url) {
  if (!url) url = window.location.href;
  name = name.replace(/[\[\]]/g, "\\$&");
  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return "";
  return decodeURIComponent(results[2].replace(/\+/g, " "));
}

export const renderURL = (url, params, formatter, acceptZero = false) => {
  let paramsValue = _.compact(
    _.map(params, (p, key) => {
      if (p || (acceptZero && p === 0)) {
        if (typeof p === "object") {
          if (Array.isArray(p)) {
            return `${key}=${JSON.stringify(p)}`;
          }
          if (p.id) return `${key}=${p.id}`;
          else {
            let formatDate = moment(p).format(
              formatter ? formatter : "YYYY-MM-DD"
            );
            return `${key}=${formatDate}`;
          }
        } else {
          return `${key}=${p}`;
        }
      }
    })
  );
  return _.map(paramsValue, (pv, index) => (!index ? pv : "&" + pv)).join("");
};

export var smoothScroll = {
  timer: null,

  stop: function () {
    clearTimeout(this.timer);
  },

  scrollTo: function (id, desTop = 0, callback) {
    var settings = {
      duration: 1000,
      easing: {
        outQuint: function (x, t, b, c, d) {
          return c * ((t = t / d - 1) * t * t * t * t + 1) + b;
        },
      },
    };
    var header = document.querySelector(".header-wrapper");

    var menuTop = document.querySelector(".menu-top");
    var headerH = header ? header.offsetHeight : 0;
    var menuTopH = menuTop ? menuTop.offsetHeight : 0;
    var percentage;
    var startTime;
    var node = document.querySelector(id);
    // var nodeTop = node.offsetTop;
    var nodeTop = node.getBoundingClientRect().top + window.scrollY;

    var nodeHeight = node.offsetHeight;
    var body = document.body;
    var html = document.documentElement;
    var height = Math.max(
      body.scrollHeight,
      body.offsetHeight,
      html.clientHeight,
      html.scrollHeight,
      html.offsetHeight
    );

    var windowHeight = window.innerHeight;
    var offset = window.pageYOffset;
    var delta = nodeTop - offset;
    var bottomScrollableY = height - windowHeight;
    var targetY = delta - desTop;
    // (bottomScrollableY < delta) ?
    // bottomScrollableY - (height - nodeTop - nodeHeight + offset) - 50:

    startTime = Date.now();
    percentage = 0;

    if (this.timer) {
      clearInterval(this.timer);
    }

    function step() {
      var yScroll;
      var elapsed = Date.now() - startTime;

      if (elapsed > settings.duration) {
        clearTimeout(this.timer);
      }

      percentage = elapsed / settings.duration;

      if (percentage > 1) {
        clearTimeout(this.timer);

        if (callback) {
          callback();
        }
      } else {
        yScroll = settings.easing.outQuint(
          0,
          elapsed,
          offset,
          targetY,
          settings.duration
        );
        window.scrollTo(0, yScroll);
        this.timer = setTimeout(step, 10);
      }
    }

    this.timer = setTimeout(step, 10);
  },
};

export function unaccent(str) {
  str = str.toLowerCase();
  //     We can also use this instead of from line 11 to line 17
  //     str = str.replace(/\u00E0|\u00E1|\u1EA1|\u1EA3|\u00E3|\u00E2|\u1EA7|\u1EA5|\u1EAD|\u1EA9|\u1EAB|\u0103|\u1EB1|\u1EAF|\u1EB7|\u1EB3|\u1EB5/g, "a");
  //     str = str.replace(/\u00E8|\u00E9|\u1EB9|\u1EBB|\u1EBD|\u00EA|\u1EC1|\u1EBF|\u1EC7|\u1EC3|\u1EC5/g, "e");
  //     str = str.replace(/\u00EC|\u00ED|\u1ECB|\u1EC9|\u0129/g, "i");
  //     str = str.replace(/\u00F2|\u00F3|\u1ECD|\u1ECF|\u00F5|\u00F4|\u1ED3|\u1ED1|\u1ED9|\u1ED5|\u1ED7|\u01A1|\u1EDD|\u1EDB|\u1EE3|\u1EDF|\u1EE1/g, "o");
  //     str = str.replace(/\u00F9|\u00FA|\u1EE5|\u1EE7|\u0169|\u01B0|\u1EEB|\u1EE9|\u1EF1|\u1EED|\u1EEF/g, "u");
  //     str = str.replace(/\u1EF3|\u00FD|\u1EF5|\u1EF7|\u1EF9/g, "y");
  //     str = str.replace(/\u0111/g, "d");
  str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, "a");
  str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, "e");
  str = str.replace(/ì|í|ị|ỉ|ĩ/g, "i");
  str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, "o");
  str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, "u");
  str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, "y");
  str = str.replace(/đ/g, "d");
  // Some system encode vietnamese combining accent as individual utf-8 characters
  str = str.replace(/\u0300|\u0301|\u0303|\u0309|\u0323/g, ""); // Huyền sắc hỏi ngã nặng
  str = str.replace(/\u02C6|\u0306|\u031B/g, ""); // Â, Ê, Ă, Ơ, Ư
  return str;
}

function formatActionRole(list) {
  if (list.length > 0) {
    const res = list.reduce((result, cur) => {
      result.push(cur.action_key);
      return result;
    }, []);
    return res;
  }
  return [];
}

export function formatPermission(module_list) {
  if (module_list && module_list.length > 0) {
    const res = module_list.reduce(
      (result, cur) => {
        result.module_roles.push(cur.layout_key);
        const action_role = formatActionRole(cur.list_action);
        result.action_roles = [...result.action_roles, ...action_role];
        return result;
      },
      {
        action_roles: [],
        module_roles: [],
      }
    );
    return res;
  }
}

export function createFilterFromUrl(urlParams, arrayOfObjects = []) {
  let hashmap = _.reduce(
    arrayOfObjects,
    function (hash, value) {
      let key = value["key"];
      let type = value["type"];

      switch (type) {
        case "number":
          hash[key] = urlParams?.get(key)
            ? +urlParams?.get(key)
            : value?.initValue;
          break;
        case "string":
          hash[key] = urlParams?.get(key) || value?.initValue;
          break;
        case "date":
          hash[key] = urlParams?.get(key)
            ? moment(urlParams?.get(key))
            : value?.initValue;
          break;
        case "array":
          hash[key] = urlParams?.get(key)
            ? JSON.parse(urlParams?.get(key))
            : value?.initValue;
          break;
        default:
          hash[key] = undefined;
          break;
      }
      return hash;
    },
    {}
  );

  return hashmap;
}

export function findInArrayByKey(
  array,
  comparativeValue,
  comparativeField = "id",
  returnKey
) {
  if (!_.isArray(array) || array?.length === 0) return;

  const result = array.find(
    (item) => item?.[comparativeField] === comparativeValue
  );
  return result && returnKey ? result?.[returnKey] : result;
}

export const numberFormat = (value, formatter = "0,0[.][00]") =>
  +value ? numeral(value).format(formatter) : 0;

export const renameFileWhenDownload = (link = "", name = "") => {
  const request = new XMLHttpRequest();
  request.open("GET", link, true);
  request.responseType = "blob";
  request.onload = function () {
    let a = document.createElement("a");
    a.href = window.URL.createObjectURL(request.response);
    a.download = name;
    a.click();
  };
  request.send();
};

export const formatRelativeTime = (dateTimeString) => {
  const now = moment();
  const targetDate = moment(dateTimeString);

  const diffInSeconds = now.diff(targetDate, "seconds");
  const diffInMinutes = now.diff(targetDate, "minutes");
  const diffInHours = now.diff(targetDate, "hours");
  const diffInDays = now.diff(targetDate, "days");

  if (diffInSeconds < 5) {
    return "vài giây trước";
  }
  if (diffInSeconds < 60) {
    return `${diffInSeconds} giây trước`;
  }
  if (diffInMinutes < 60) {
    return `${diffInMinutes} phút trước`;
  }
  if (diffInHours < 24) {
    return `${diffInHours} giờ trước`;
  }
  if (diffInDays === 1) {
    return `hôm qua lúc ${targetDate.format("HH:mm")}`;
  }
  if (now.isSame(targetDate, "year")) {
    return `${targetDate.format("DD/MM")} lúc ${targetDate.format("HH:mm:ss")}`;
  }
  return `${targetDate.format("DD/MM/YYYY")} lúc ${targetDate.format(
    "HH:mm:ss"
  )}`;
};

export const isUUID = (str = "") => {
  const uuidRegex =
    /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
  return uuidRegex.test(str);
};

export const convertTitle = (str = "") =>
  str
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/\s+/g, "-");

export const showChangePasswordConfirmation = (
  apiFunc,
  id,
  payload = null,
  options = {}
) => {
  const defaultOptions = {
    title: "Xác nhận thay đổi mật khẩu",
    confirmButtonText: "Đồng ý",
    cancelButtonText: "Hủy bỏ",
    buttonColor: "#3085d6",
    cancelColor: "#d33",
    successTitle: "Thay đổi mật khẩu thành công!",
    successButtonColor: "#e4e6eb",
    successColor: "#28a745",
    errorColor: "#dc3545",
  };

  const config = { ...defaultOptions, ...options };

  const handleAPICall = async () => {
    try {
      const response = payload ? await apiFunc(id, payload) : await apiFunc(id);
      return response;
    } catch (error) {
      console.error("Lỗi khi gọi API:", error);
      return null;
    }
  };

  const handlePasswordDisplay = (newPassword) => {
    Swal.fire({
      title: config.successTitle,
      html: `
        <div style="margin-top: 10px; display: flex; align-items: center; gap: 10px; justify-content: center">
          <p style="margin: 0;">Mật khẩu là: <strong id="password">${newPassword}</strong></p>
          <button 
            id="copy-button" 
            style="
              background-color: ${config.successButtonColor}; 
              border: none; 
              color: #333; 
              padding: 5px 10px; 
              border-radius: 5px; 
              cursor: pointer;
            ">
            Sao chép
          </button>
        </div>
      `,
      icon: "success",
      confirmButtonText: config.confirmButtonText,
    });

    setTimeout(() => {
      const copyButton = document.getElementById("copy-button");
      const passwordElement = document.getElementById("password");

      if (copyButton && passwordElement) {
        copyButton.addEventListener("click", () => {
          navigator.clipboard
            .writeText(passwordElement.textContent)
            .then(() => {
              copyButton.textContent = "Đã sao chép";
              copyButton.style.backgroundColor = config.successColor;
              copyButton.style.color = "#fff";
              copyButton.style.cursor = "default";
              copyButton.disabled = true;
            })
            .catch(() => {
              copyButton.textContent = "Lỗi sao chép";
              copyButton.style.backgroundColor = config.errorColor;
              copyButton.style.color = "#fff";
            });
        });
      }
    }, 0);
  };

  Swal.fire({
    title: config.title,
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: config.buttonColor,
    cancelButtonColor: config.cancelColor,
    confirmButtonText: config.confirmButtonText,
    cancelButtonText: config.cancelButtonText,
    reverseButtons: true,
    showLoaderOnConfirm: true,
    preConfirm: handleAPICall,
    allowOutsideClick: () => !Swal.isLoading(),
  }).then((result) => {
    if (result.isConfirmed && result.value?.status === 200) {
      const { new_password } = result.value.data;
      handlePasswordDisplay(new_password);
    } else {
      console.error("Reset mật khẩu không thành công.");
    }
  });
};

export const formatNumber = (number) => {
  if (number === undefined) return "";
  return numeral(number).format("0,0");
};

export const formatDate = (value) => {
  if (!value) return "";
  return moment(value).format("DD/MM/YYYY HH:mm:ss");
};

export const formatUTCDate = (value) => {
  if (!value) return "";
  return moment.utc(value).format("DD/MM/YYYY HH:mm:ss");
};

export const formatDateImportBarcode = (dateStr) => {
  return moment(dateStr, "DD/MM/YYYY HH:mm:ss")
    .subtract(7, "hours")
    .format("DD/MM/YYYY HH:mm:ss");
};

export const filterOptionSelect = (inputValue, option) => {
  const normalize = (str) => unaccent(str).toLowerCase().trim();

  const label = typeof option.label === "string" ? option.label : "";

  return (
    normalize(label).includes(normalize(inputValue)) ||
    normalize(inputValue).includes(normalize(label))
  );
};

export const filterOptionByLabelOrName = (input, option) => {
  const field = option.label || option.name;
  return field
    ? unaccent(field.toLowerCase()).includes(unaccent(input.toLowerCase()))
    : false;
};

export const formatValueToNumber = (value) => {
  if (value === undefined || value === "") return "";
  return numeral(value).format("0,0");
};

export const parserValueToNumber = (value) => {
  if (value === "0") return value;
  return numeral(value).value() || "";
};

export const formatInputNumber = {
  formatter: formatValueToNumber,
  parser: parserValueToNumber,
};

export const formatDateToString = (value, pattern = "DD/MM/YYYY HH:mm:ss") => {
  if (!value) return "";
  return moment(value).format(pattern);
};